import { render, staticRenderFns } from "./page-input.vue?vue&type=template&id=4b607212&"
import script from "./page-input.vue?vue&type=script&lang=js&"
export * from "./page-input.vue?vue&type=script&lang=js&"
import style0 from "./page-input.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4b607212', component.options)
    } else {
      api.reload('4b607212', component.options)
    }
    module.hot.accept("./page-input.vue?vue&type=template&id=4b607212&", function () {
      api.rerender('4b607212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/page-input.vue"
export default component.exports